import { I18nLang } from '@pharmsnap/shared/src/i18n'
import { getTextByLang } from '@pharmsnap/shared/src/utils/lang'

export type IPropertyOptionName = {
  display_name_cn: string
  display_name_en: string
  display_name_jp: string
}

type IPropertyOption = IPropertyOptionName & {
  value: string
  options: IPropertyOptionItem[]
}

type IPropertyOptionItem = IPropertyOptionName & {
  value: string
  disabled?: boolean
}

export const renderPropertyOptions: IPropertyOption[] = [
  {
    display_name_cn: '药物属性',
    display_name_en: 'Drug Properties',
    display_name_jp: '医薬品属性',
    value: 'drugProperties',
    options: [
      {
        display_name_cn: '药物',
        display_name_en: 'Drug',
        display_name_jp: '医薬品',
        value: 'drug',
      },
      {
        display_name_cn: '药物类型',
        display_name_en: 'Drug Type',
        display_name_jp: '医薬品タイプ',
        value: 'drugType',
      },
      {
        display_name_cn: '靶点',
        display_name_en: 'Target',
        display_name_jp: '標的',
        value: 'target',
      },
      {
        display_name_cn: '适应症',
        display_name_en: 'Indication',
        display_name_jp: '適応症',
        value: 'indication',
      },
      {
        display_name_cn: '机构',
        display_name_en: 'Organization',
        display_name_jp: '組織',
        value: 'organization',
      },
      {
        display_name_cn: '机构属性',
        display_name_en: 'Organization Attributes',
        display_name_jp: '組織属性',
        value: 'organizationProperty',
      },
      {
        display_name_cn: '最高阶段',
        display_name_en: 'Highest Phase',
        display_name_jp: '最高開発段階',
        value: 'highestPhase',
      },
      {
        display_name_cn: '作用机制',
        display_name_en: 'MOA',
        display_name_jp: '作用機序',
        value: 'moa',
      },
      {
        display_name_cn: '化学修饰',
        display_name_en: 'Chemical Modification',
        display_name_jp: '化学修飾',
        value: 'chemicalModification',
      },
      {
        display_name_cn: '里程碑',
        display_name_en: 'Milestone',
        display_name_jp: 'マイルストーン',
        value: 'milestone',
      },
      {
        display_name_cn: '存在交易',
        display_name_en: 'Deal',
        display_name_jp: 'ディールあり',
        value: 'deal',
      },
      {
        display_name_cn: 'ATC',
        display_name_en: 'ATC',
        display_name_jp: 'ATC',
        value: 'atc',
      },
      {
        display_name_cn: '关键词',
        display_name_en: 'Keyword',
        display_name_jp: 'キーワード',
        value: 'keyword',
      },
    ],
  },
  {
    display_name_cn: '研发状态',
    display_name_en: 'R&D Status',
    display_name_jp: '開発ステータス',
    value: 'rdStatus',
    options: [
      {
        display_name_cn: '当前研发状态',
        display_name_en: 'Current R&D Status',
        display_name_jp: '現在の開発ステータス',
        value: 'currentRdStatus',
      },
    ],
  },
]

/** 属性选项的界面语言取值,日文缺失时降级取英文 */
export function getPropertyOptionName(option: IPropertyOptionName | undefined, locale: I18nLang): string {
  if (!option) return ''
  return getTextByLang({ cn: option.display_name_cn, en: option.display_name_en, jp: option.display_name_jp }, locale)
}
